import { getClosedTransactionsWithoutClosure } from '../../../services/pos/transactions';

export const CLOSED_TRANSACTIONS_FETCH = 'CLOSED_TRANSACTIONS_FETCH';
export const CLOSED_TRANSACTIONS_SUCCESS = 'CLOSED_TRANSACTIONS_SUCCESS';
export const CLOSED_TRANSACTIONS_ERROR = 'CLOSED_TRANSACTIONS_ERROR';

export const getClosedTransactions = (page, pageSize) => async (dispatch) => {
  dispatch({ type: CLOSED_TRANSACTIONS_FETCH });
  try {
    const payload = await getClosedTransactionsWithoutClosure(page, pageSize);
    dispatch({ type: CLOSED_TRANSACTIONS_SUCCESS, payload });
  } catch (error) {
    const errorResponse = error.response;

    let errorCode;
    switch (errorResponse?.data?.error) {
      case 'INVALID_CREDENTIALS':
        errorCode = errorResponse?.data?.error;
        break;
      default:
        errorCode = 'UNKNOWN_ERROR';
    }

    dispatch({ type: CLOSED_TRANSACTIONS_ERROR, error: errorCode });
  }
};
